import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    // Expose for the ScrollToTop helper so it can perform an immediate jump
    // on route change instead of competing with smooth scrolling.
    window.__lenis = lenis;
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    return () => { lenis.destroy(); if (window.__lenis === lenis) delete window.__lenis; };
  }, []);
  return null;
}
